import { createTheme, type Theme } from "@mui/material/styles";
import type { PaletteMode } from "@mui/material";

/** Pure presentation concern: builds the MUI theme for a given color mode. */
export function buildTheme(mode: PaletteMode): Theme {
  return createTheme({
    palette: {
      mode,
      primary: { main: mode === "dark" ? "#5B8DEF" : "#1D4ED8" },
      secondary: { main: mode === "dark" ? "#34D399" : "#059669" },
      background:
        mode === "dark"
          ? { default: "#0F1417", paper: "#171C20" }
          : { default: "#F7F8FA", paper: "#FFFFFF" },
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: [
        "Inter",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "sans-serif",
      ].join(","),
    },
  });
}
